import React, { useState } from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addNewsletter } from "../redux/actions/profile";
import { toast } from "react-toastify";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useDispatch();

  const handleNewsletterSubmit = async () => {
    if (!email.trim()) {
      toast.error("Please enter your email");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email address");
      return;
    }

    setIsSubmitting(true);
    try {
      await dispatch(addNewsletter({ email })).unwrap();
      toast.success("Successfully subscribed to newsletter!");
      setEmail("");
    } catch (error) {
      toast.error(error.message || "Failed to subscribe to newsletter");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <section className="footer-main">
        <div className="join-newsletter">
          <Container>
            <div className="newsletter-card">
              <img
                className="bg-img"
                src={require("../assets/images/newsletter-side-img.png")}
              />
              <img
                className="shape-img"
                src={require("../assets/images/newsletter-shape-img.png")}
              />
              <h2>Join my newsletter</h2>
              <p>
                Receive fresh articles straight in your inbox, every Friday
                morning.
                <br /> I also share interesting finds from the internet!
              </p>

              <div className="">
                <input 
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <button 
                  onClick={handleNewsletterSubmit}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Subscribing..." : "Subscribe"}
                </button>
              </div>

              <span>
                Weekly newsletter only. No spam, unsubscribe at any time.
              </span>
            </div>
          </Container>
        </div>
        <div className="social-info">
          <Container>
            <div className="social-info-links">
              <ul>
                <li>
                  <Link to="">About us</Link>
                </li>
                <li>
                  <Link to="">Discover</Link>
                </li>
                <li>
                  <Link to="">Explore</Link>
                </li>
                <li>
                  <Link to="">Buy QR Code</Link>
                </li>
              </ul>
              <ul>
                <li>
                  <Link to="">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="39"
                      height="39"
                      viewBox="0 0 39 39"
                      fill="none"
                    >
                      <path
                        d="M20.5806 38.5309H2.12661C0.951772 38.5309 0 37.5785 0 36.4042V2.12659C0 0.951914 0.951921 0 2.12661 0H36.4044C37.5788 0 38.5309 0.951914 38.5309 2.12659V36.4042C38.5309 37.5787 37.5787 38.5309 36.4044 38.5309H26.5858V23.6096H31.5942L32.3441 17.7945H26.5858V14.082C26.5858 12.3984 27.0533 11.251 29.4675 11.251L32.5468 11.2497V6.04862C32.0143 5.97776 30.1864 5.81943 28.0598 5.81943C23.6201 5.81943 20.5806 8.5294 20.5806 13.5061V17.7945H15.5594V23.6096H20.5806V38.5309Z"
                        fill="#0A142F"
                      />
                    </svg>
                  </Link>
                </li>
                <li>
                  <Link to="">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="39"
                      height="33"
                      viewBox="0 0 39 33"
                      fill="none"
                    >
                      <path
                        d="M38.5309 3.80114C37.1151 4.44587 35.5908 4.88188 33.9919 5.07669C35.6248 4.0748 36.8777 2.48616 37.468 0.593711C35.9391 1.52138 34.2497 2.19627 32.4449 2.55806C31.0066 0.983334 28.9508 0 26.6756 0C22.313 0 18.7736 3.62952 18.7736 8.10555C18.7736 8.741 18.8414 9.3579 18.9771 9.95161C12.4071 9.61301 6.58352 6.38935 2.68226 1.47964C2.00152 2.68098 1.61252 4.0748 1.61252 5.55908C1.61252 8.36993 3.00793 10.8515 5.12931 12.3056C3.83568 12.2662 2.61441 11.8974 1.54694 11.2944V11.3941C1.54694 15.3228 4.27217 18.5998 7.89073 19.342C7.22808 19.5322 6.52924 19.6272 5.80779 19.6272C5.29893 19.6272 4.80138 19.5785 4.31966 19.4835C5.32607 22.7025 8.24354 25.0472 11.7038 25.1098C8.99891 27.2852 5.58842 28.5816 1.88618 28.5816C1.2484 28.5816 0.617417 28.5445 0 28.4703C3.4987 30.7663 7.65552 32.1091 12.1177 32.1091C26.6598 32.1091 34.6093 19.7594 34.6093 9.04713C34.6093 8.69462 34.6025 8.3421 34.5889 7.99654C36.1336 6.85319 37.4747 5.42689 38.5309 3.80114Z"
                        fill="#0A142F"
                      />
                    </svg>
                  </Link>
                </li>
                <li>
                  <Link to="">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="39"
                      height="34"
                      viewBox="0 0 39 34"
                      fill="none"
                    >
                      <path
                        d="M38.5115 7.79491C38.3439 11.5945 35.7204 16.7886 30.6592 23.3793C25.4214 30.271 20.9832 33.7145 17.3561 33.7145C15.1133 33.7145 13.2125 31.6195 11.6606 27.4155C10.6207 23.5585 9.58767 19.7014 8.55006 15.8559C7.39465 11.6497 6.15768 9.54769 4.83461 9.54769C4.54689 9.54769 3.54327 10.1611 1.81241 11.3901L0 9.02163C1.8985 7.33317 3.76982 5.63781 5.61622 3.94705C8.14453 1.72793 10.0453 0.563231 11.314 0.441478C14.3045 0.147433 16.1486 2.22183 16.8441 6.65778C17.5849 11.4475 18.106 14.4247 18.3937 15.5917C19.2592 19.5613 20.2061 21.5415 21.2438 21.5415C22.048 21.5415 23.2578 20.2597 24.8708 17.6937C26.4839 15.1231 27.3425 13.1704 27.4603 11.8242C27.6914 9.60512 26.8283 8.50245 24.8708 8.50245C23.9488 8.50245 22.9973 8.70002 22.0208 9.11352C23.9239 2.86735 27.5487 -0.169585 32.9044 0.00730192C36.8713 0.119866 38.7449 2.72033 38.5115 7.79491Z"
                        fill="#0A142F"
                      />
                    </svg>
                  </Link>
                </li>
                <li>
                  <Link to="">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="39"
                      height="28"
                      viewBox="0 0 39 28"
                      fill="none"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M36.614 2.03601C37.7687 3.21348 38.1456 5.88733 38.1456 5.88733C38.1456 5.88733 38.5309 9.02805 38.5309 12.1676V15.1118C38.5309 18.2525 38.1456 21.3921 38.1456 21.3921C38.1456 21.3921 37.7687 24.0659 36.614 25.2434C35.2938 26.6363 33.83 26.7802 33.0025 26.8616C32.9115 26.8705 32.8282 26.8787 32.7537 26.8877C27.3618 27.2806 19.2655 27.2927 19.2655 27.2927C19.2655 27.2927 9.24742 27.2006 6.16495 26.9023C6.0189 26.8748 5.84186 26.8534 5.64137 26.8292C4.66497 26.7112 3.13245 26.5261 1.91571 25.2434C0.760985 24.0659 0.385309 21.3921 0.385309 21.3921C0.385309 21.3921 0 18.2525 0 15.1118V12.1676C0 9.02805 0.385309 5.88733 0.385309 5.88733C0.385309 5.88733 0.760985 3.21348 1.91571 2.03601C3.23884 0.641136 4.70407 0.498774 5.53156 0.418376C5.62128 0.409659 5.7035 0.401671 5.77723 0.392893C11.1691 0 19.257 0 19.257 0H19.2739C19.2739 0 27.3618 0 32.7537 0.392893C32.8274 0.401684 32.9097 0.409683 32.9995 0.418415C33.8263 0.49882 35.2922 0.641362 36.614 2.03601ZM15.2859 7.77634L15.2871 18.6791L25.6965 13.2465L15.2859 7.77634Z"
                        fill="#0A142F"
                      />
                    </svg>
                  </Link>
                </li>
              </ul>
            </div>
            <div className="social-other-links">
              <p>© 2025 Summer Rose. All rights reserved.</p>
              <ul>
                <li>
                  <Link to="">Terms of Service</Link>
                </li>
                <li>
                  <Link to="">Privacy Policy</Link>
                </li>
              </ul>
            </div>
          </Container>
        </div>
      </section>
    </>
  );
}
